<template>
  <b-table class="mt-2" striped hover :fields="fields" :items="rows">
  </b-table>
</template>

<script>
import articles from '@/modules/articles.js'

export default {
  name: 'ArticleInfoLinks',
  props: ["articleid"],
  data() {
    return {
      fields: [
        {label:"Artikel",key:"article_id"},
        {label:"Referenz-ID",key:"text"},
        {label:"Type",key:"count"},
        {label:"Inhalt",key:"price"},
      ],
      rows: []
    }
  },
  watch: {
    priceid: function() { console.log('watch:' + this.articleid); this.fetchData(); }
  },
  methods: {
    fetchData: function() {
      var self = this;
      articles.infolinks(this.articleid,this,function(data) {
        self.rows = data;
      })
    }
  }
}
</script>
